<template>
  <div>
    <BordsList />
  </div>

</template>
<script>
import BordsList from './devices_control/boards.vue'
import axios from "axios"
export default {
  name: "HomeDevicesControl",
  components: {
    BordsList
  },
  data: () => ({
    key: localStorage.getItem('key'),
    tab: null,
    loading:true,
    detail:{
      en:false,
      name:null,
      view:"temp",
      data:[],
    },
    chartData : {
      labels:[],
      datasets:[{
        label:"",
        backgroundColor: '#D20003',
        data:[]
      }]
    },
    devices: {
      temps: [],
      relays: [],
    },


  }),
  created() {
  },
  methods: {
    show_detail(name, view){
      this.loading = true;
      axios
          .get(`${this.BACKEND_LINK}/api/devices-data/detail/?field_name=${name}`, {
            headers: { 'Authorization': `Token ${this.key}` }
          })
          .then(response => {
            this.detail={
              en:true,
              name:name,
              view:view,
              data:response.data
            }
            if (view === "temp"){
              this.chartData.datasets[0].label="دما"
            }
            else if (view === "relay"){
              this.chartData.datasets[0].label="وضعیت رله"
            }
            else if (view === "hum"){
              this.chartData.datasets[0].label="رطوبت"
            }
            else {
              this.chartData.datasets[0].label = "ولت"
            }
            for(let i=0;i < response.data.length;i++){
              this.chartData.labels.push(
                  new Date(response.data[i]['_time']).toLocaleString("fa-ir").split(',')[1]
              );
              this.chartData.datasets[0].data.push(response.data[i]['_value']);
            }
            this.loading = false;
          })
          .catch((errors) => {
            this.loading = false;
            this.$snotify.error('خطا در دریافت اطلاعات', `کد ${errors.response.code}‍‍‍`)
          })
    },
    get_devices() {
      this.loading = true;
      axios
          .get(`${this.BACKEND_LINK}/api/devices-data/`, {
            headers: { 'Authorization': `Token ${this.key}` }
          })
          .then(response => {
            this.devices = response.data;
            this.loading = false;
          })
          .catch((errors) => {
            this.loading = false;
            this.$snotify.error('خطا در دریافت اطلاعات', `کد ${errors.response.code}‍‍‍`)
          })
    },
  }
}
</script>